<template>
    <Card
        class="col-span-12 md:col-span-3 relative"
        :class="{
            'ring-2 ring-inset ring-active':
                integration.state === IntegrationStateEnum.Active,
        }"
    >
        <template #content>
            <div class="absolute top-4 right-4">
                <Icon
                    v-if="integration.state === IntegrationStateEnum.Active"
                    name="circle-check"
                    class="w-6 h-6 text-active"
                />
                <Icon
                    v-else
                    name="close-circle"
                    class="w-6 h-6 text-red-600"
                />
            </div>
            <div class="space-y-4">
                <div>
                    <Image
                        class="max-h-32 w-auto mx-auto object-cover"
                        :src="providerData.thumbUrl"
                    />
                </div>
                <div class="text-xs font-semibold uppercase text-gray-600">
                    {{ integration.name }}
                </div>
            </div>
            <div class="mt-2 flex flex-col justify-end gap-1">
                <slot name="actions" />
                <DeleteIntegrationButtonModal
                    @onSuccess="emit('onIntegrationDeleted')"
                    :integration="integration"
                />
            </div>
        </template>
    </Card>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Integration from '@/App/Integration/Entity/Integration'
    import Card from '@/Shared/Component/Card.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import DeleteIntegrationButtonModal from '@/App/Integration/Component/DeleteIntegrationButtonModal.vue'
    import {
        IntegrationStateEnum,
        type IntegrationProviderDataType,
    } from '@/Shared/AutoGenerated/Main'
    import Image from '@/Shared/Component/Image.vue'

    const emit = defineEmits(['onIntegrationDeleted'])

    const props = defineProps({
        integration: {
            type: Object as PropType<Integration>,
            required: true,
        },
        providerData: {
            type: Object as PropType<IntegrationProviderDataType>,
            required: true,
        },
    })
</script>
